'use strict';
/* eslint no-sync: 0 */
const angular = require('angular');

import navbar, { Navbar } from '../../models/navbar.model';
import { isString } from 'lodash';

export class NavbarComponent {
  menu = [{
    'title': 'Home',
    'link': '/'
  }];
  $location;
  isLoggedIn: Function;
  isAdmin: Function;
  hasRole: Function;
  getCurrentUser: Function;
  isCollapsed = true;
  Navbar: Navbar;
  getAvailableLanguages: Function;
  getCurrentLanguage: Function;
  useLanguage: Function;
  initialized: Boolean = false;
  toggled: Boolean[] = [];

  burgerToggled = false;

  constructor($location, private Auth, $translate) {
    'ngInject';
    this.$location = $location;
    Auth.isLoggedIn().then(is => {
      console.log('logged role:', is);

      this.initialized = true;
      this.isLoggedIn = Auth.isLoggedInSync;
      this.isAdmin = Auth.isAdminSync;
      this.hasRole = Auth.hasRoleSync;
      this.getCurrentUser = Auth.getCurrentUserSync;
    });
    this.Navbar = navbar;
    this.getAvailableLanguages = $translate.getAvailableLanguageKeys;
    this.getCurrentLanguage = $translate.proposedLanguage;
    this.useLanguage = $translate.use;
  }
  toggleBurger() {
    this.burgerToggled = !this.burgerToggled;
  }
  closeBurger() {
    this.burgerToggled = false;
  }

  toggleDropdown(index: number) {
    this.toggled[index] = !this.toggled[index];
  }

  isAuthorized(role: String | Boolean) {
    let authorized = true;
    if (isString(role)) {
      authorized = this.hasRole(role);
    } else if (role) {
      authorized = this.isLoggedIn();
    }
    // console.log('isAuthorized', role, authorized);
    return authorized;
  }

  isActive(route) {
    return route === this.$location.path();
  }
}

export default angular.module('directives.navbar', [])
  .component('navbar', {
    template: require('./navbar.pug'),
    controller: NavbarComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/navbar/navbar.component.ts